import { Component } from 'react';
import { compose } from 'recompose';
import { ChartFragment, Section } from 'models/api-response';
import { FormFieldInputType } from 'models/enum';
import { ChartActionsComponentProps, ChartComponentProps, ChartMetaFormField } from 'models/ui';
import { chartHelper } from 'helpers';
import { chartService } from 'services';
import { withChartLogic } from 'components/common';
import withSavedPatientChartsPage from 'components/features/shared/withSavedPatientChartsPage';
import { FormField, SectionTitle } from './constants';
import IntegumentaryInterventionsView from './IntegumentaryInterventionsView';
import { Title } from '../shared/constants';

class IntegumentaryInterventions extends Component<ChartComponentProps> {
  static displayName = 'IntegumentaryInterventions';

  componentDidMount() {
    this.props.initState(this.buildDefaultFormFields());
  }

  buildDefaultFormFields = (): Map<string, ChartMetaFormField> => {
    const { createFormField } = chartHelper;
    const dataMap = new Map();

    const multiselectDropdowns = [FormField.SKIN_CARE, FormField.WOUND_CARE, FormField.PATIENT_RESPONSE];

    dataMap.set(FormField.NO_CARE, createFormField({ name: FormField.NO_CARE, type: FormFieldInputType.CHECK_BOX }));
    multiselectDropdowns.forEach((name) => dataMap.set(name, createFormField({ name, type: FormFieldInputType.MULTISELECT_DROPDOWN })));
    dataMap.set(FormField.INTEGUMENTARY_CARE_NOTES, createFormField({ name: FormField.INTEGUMENTARY_CARE_NOTES, type: FormFieldInputType.TEXT_AREA }));
    return dataMap;
  };

  createSections = (): Section[] => {
    const { formFieldMap } = this.props;
    const { buildSection } = chartHelper;
    return [
      buildSection({ sectionTitle: SectionTitle.INTEGUMENTARY_INTERVENTIONS, fields: [FormField.NO_CARE], formFieldMap }),
      buildSection({ sectionTitle: SectionTitle.SKIN_CARE, fields: [FormField.SKIN_CARE], formFieldMap }),
      buildSection({ sectionTitle: SectionTitle.WOUND_CARE, fields: [FormField.WOUND_CARE], formFieldMap }),
      buildSection({ sectionTitle: SectionTitle.PATIENT_RESPONSE, fields: [FormField.PATIENT_RESPONSE], formFieldMap }),
      buildSection({ sectionTitle: SectionTitle.INTEGUMENTARY_CARE_NOTES, fields: [FormField.INTEGUMENTARY_CARE_NOTES], formFieldMap })
    ];
  };

  buildFragment = () => {
    const record = {
      chartTitle: Title.SYSTEM_NURSING_INTERVENTIONS,
      fragmentTitle: SectionTitle.INTEGUMENTARY_INTERVENTIONS,
      records: this.createSections()
    };
    const cleanRecord = chartService.systemAssessment.removeEmptyRecords(record);
    const basicInfo = chartService.createBaseFragment({ chartingTime: this.props.chartingTime });
    return { ...basicInfo, chartData: cleanRecord } as ChartFragment;
  };

  handleSaveClick = () => {
    this.props.saveChart([this.buildFragment()], { afterSave: this.props.backToSourceLocation || this.props.navigateToSavedPatientCharting });
  };

  render() {
    const chartActionsProps: ChartActionsComponentProps = {
      enableDisplayRecordsButton: this.props.enableDisplayRecordsButton,
      enableSaveButton: this.props.hasUnsavedChanges,
      onCancelClick: () => this.props.handleDiscardClick(undefined, this.buildDefaultFormFields()),
      onDisplayRecordsClick: this.props.displayAuthoringData,
      onSaveClick: this.handleSaveClick
    };
    const viewProps = {
      chartActionsProps,
      formFieldMap: this.props.formFieldMap,
      formSubmittedCount: this.props.formSubmittedCount
    };
    return <IntegumentaryInterventionsView {...viewProps} />;
  }
}

export { IntegumentaryInterventions as BaseIntegumentaryInterventions };
export default compose(withSavedPatientChartsPage, withChartLogic)(IntegumentaryInterventions);
